<template>
  <div class="flex items-center">
    <div class="">
      <div
        class="btn btn-red"
        :class="{ 'bg-gray-400 hover:bg-gray-400 text-gray-800': !value }"
        @click="clear"
      >
        <i class="far fa-times-circle"></i>
      </div>
    </div>
    <div class="flex-grow px-1">
      <flat-pickr
        v-model="flatpickrValue"
        :config="flatpickrConfig"
        class="appearance-none text-xs block rounded py-2 px-2 focus:outline-none w-full bg-theme-300 border border-theme-200 light:border-theme-800 light:bg-theme-600"
        :placeholder="rule.name"
        :id="'flatpickr-date-' + rule.key"
        :name="rule.key"
      ></flat-pickr>
    </div>
    <div class="">
      <div
        class="btn btn-blue"
        :class="{ 'bg-gray-400 hover:bg-gray-400 text-gray-800': !flatpickrValue }"
        @click="update"
      >
        <i class="fas fa-search"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    rule: {},
    value: {},
  },
  data() {
    return {
      flatpickrValue: '',
      flatpickrConfig: {},
    }
  },
  watch: {
    value() {
      this.flatpickrValue = this.value
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
    })
  },
  created() {
    this.flatpickrConfig = Object.assign({}, this.config.flatpickrConfig)
    for (let i in this.rule.flatpickr) {
      this.flatpickrConfig[i] = this.rule.flatpickr[i]
    }
  },
  methods: {
    update() {
      if (!this.flatpickrValue) {
        return
      }
      this.$emit('input', this.flatpickrValue)
    },
    clear() {
      if (!this.value) {
        return
      }
      this.flatpickrValue = this.rule.default
      this.$emit('input', this.flatpickrValue)
    }
  }
}
</script>
